import { render, staticRenderFns } from "./CadastroGrade.vue?vue&type=template&id=b6abfac8"
import script from "./CadastroGrade.vue?vue&type=script&lang=js"
export * from "./CadastroGrade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports